package com.shadowings.gero.presentation.screen

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.UniliteralExplanation
import com.shadowings.gero.domain.repository.LessonContentRepository
import com.shadowings.gero.presentation.model.LandingUiState
import com.shadowings.gero.presentation.model.Word
import com.shadowings.gero.util.systemLanguageCode
import org.koin.compose.koinInject

@Composable
fun CompendioScreen(
    uiState: LandingUiState,
    onToggleFavoriteHiero: (String) -> Unit,
    onToggleFavoriteWord: (String) -> Unit,
    onWordViewed: (Word) -> Unit,
    onHieroViewed: (Hiero) -> Unit,
    onRuleClick: (String) -> Unit = {},
    onTabSelected: (Int) -> Unit = {},
    modifier: Modifier = Modifier
) {
    val lessonContentRepository: LessonContentRepository = koinInject()

    // Calcolo degli elementi visti nelle lezioni completate
    val seenData =
        remember(uiState.userData.stars, uiState.hieros, uiState.words, uiState.userData.language) {
            val completedLessonIds = uiState.userData.stars.filterValues { it > 0 }.keys
            val seenHieros = mutableSetOf<String>()
            val seenWords = mutableSetOf<String>()
            val languageCode = uiState.userData.language.ifBlank { systemLanguageCode() }

            for (lessonId in completedLessonIds) {
                seenWords.addAll(lessonContentRepository.getQuizOnlyWordIds(lessonId))
                val explanations = lessonContentRepository.getExplanationContent(
                    lessonId,
                    uiState.hieros,
                    uiState.words,
                    languageCode
                )
                for (explanation in explanations) {
                    when (explanation) {
                        is UniliteralExplanation -> {
                            seenHieros.add(explanation.id)
                        }

                        is ExplanationContent -> {
                            explanation.wordId?.let { seenWords.add(it) }
                        }
                    }
                }
            }

            // Se una parola è vista, tutti i suoi geroglifici sono considerati visti — ma solo i
            // frammenti che corrispondono a un segno reale del catalogo: la stessa suddivisione
            // grezza usata per insegnare i segni include anche notazioni di posizionamento/
            // sovrapposizione (es. "Z1h0", "N29w0") che non sono voci di hiero.tsv, e contarle
            // come "viste" gonfierebbe seenHieros oltre la dimensione reale del catalogo.
            val validHieroCodes = uiState.hieros.map { it.gardinerCode }.toSet()
            uiState.words.filter {
                it.id in seenWords || it.isSeen(seenWords)
            }.forEach { word ->
                val wordCodes = (listOfNotNull(word.gardiner, word.alt1, word.alt2))
                    .flatMap { it.split(Regex("[^a-zA-Z0-9]+")) }
                    .filter { it.isNotBlank() && it in validHieroCodes }
                seenHieros.addAll(wordCodes)
            }

            Pair(seenHieros, seenWords)
        }

    val seenHieroCodes = seenData.first
    val seenWordIds = seenData.second

    CompendioScreenContent(
        uiState = uiState,
        seenHieroCodes = seenHieroCodes,
        seenWordIds = seenWordIds,
        onToggleFavoriteHiero = onToggleFavoriteHiero,
        onToggleFavoriteWord = onToggleFavoriteWord,
        onWordViewed = onWordViewed,
        onHieroViewed = onHieroViewed,
        onRuleClick = onRuleClick,
        onTabSelected = onTabSelected,
        modifier = modifier
    )
}
